import { UserRoles } from '../../../types/models/user/user.types';

export const getUserRoleLabel = (role?: UserRoles) => {
  switch (role) {
    case UserRoles.AcheteurPublic:
      return 'Acheteur public';
    case UserRoles.Entreprise:
      return 'Entreprise';
    case UserRoles.Commercial:
      return 'Commercial';
    case UserRoles.DirecteurCommercial:
      return 'Directeur Commercial';
    default:
      return 'Utilisateur';
  }
};
